"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ObjectDetailButton = exports.ObjectDetailInfoBar = exports.ObjectDetailPageHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var Bookmark = _interopRequireWildcard(require("bookmark"));

var Share = _interopRequireWildcard(require("share"));

var _PromotionCode = babelHelpers.interopRequireDefault(require("components/PromotionCode"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _Discussion = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _SubmissionInfoBar = require("components/SubmissionInfoBar");

var _userProfile = require("user-profile");

var _noty = require("noty");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _class5, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _class7, _descriptor20, _descriptor21, _class9, _descriptor22, _descriptor23, _descriptor24, _class11, _descriptor25, _descriptor26, _class13, _descriptor27, _class15, _descriptor28, _descriptor29, _descriptor30, _class17, _descriptor31, _class19, _descriptor32, _class21, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _class23, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _class25, _descriptor43, _class27, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _class29, _descriptor49, _class31, _descriptor50, _class33, _descriptor51, _class35, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _class37, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _class39, _descriptor62, _descriptor63, _class41, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _class43, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _class45, _descriptor81;

var _excluded = ["component"],
    _excluded2 = ["tagName", "exposed"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}


function NoOp() {}

function MaybeLink(props) {
  var which;
  if (props.href) which = props.linked || {
    component: 'a'
  };else which = props.unlinked || {
    component: 'span'
  };
  var href = props.href,
      children = props.children;
  var _which = which,
      Component = _which.component,
      rest = babelHelpers.objectWithoutProperties(_which, _excluded);
  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, rest, {
    href: href
  }), children);
}

var InfoItem = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(InfoItem, _Component);

  var _super = _createSuper(InfoItem);

  function InfoItem() {
    var _this;

    babelHelpers.classCallCheck(this, InfoItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "className", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "metadataFetch", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "value", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "transcriptData", _descriptor4, babelHelpers.assertThisInitialized(_this));
    _this.state = {
      metadata: null,
      err: false
    };
    return _this;
  }

  babelHelpers.createClass(InfoItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.metadataFetch) {
        (0, _fetch.default)(this.metadataFetch).then(function (r) {
          return r.json();
        }).catch(function (e) {
          return null;
        }).then(function (value) {
          return _this2.setState({
            metadata: value,
            err: value == null
          });
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (prevProps.metadataFetch != this.props.metadataFetch) {
        this.setState({
          metadata: null
        });

        if (this.metadataFetch) {
          (0, _fetch.default)(this.metadataFetch).then(function (r) {
            return r.json();
          }).catch(function (e) {
            return null;
          }).then(function (metadata) {
            return _this3.setState({
              metadata: metadata,
              err: metadata == null
            });
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.metadataFetch) {
        if (!this.state.metadata) return null;
        var t = Math.round(this.state.metadata.fullLength);
        var seconds = t % 60;
        t -= seconds;
        t /= 60;

        if (!t) {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: this.className,
            "data-value": "".concat(seconds, "s")
          });
        }

        var minutes = t % 60;
        t -= minutes;

        if (!t) {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: this.className,
            "data-value": "".concat(minutes, "m").concat(seconds ? " ".concat(seconds, "s") : '')
          });
        }

        return /*#__PURE__*/_react.default.createElement("span", {
          className: this.className,
          "data-value": "".concat(t, "h").concat(minutes ? " ".concat(minutes, "m") : '')
        });
      }

      if (this.value) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: this.className,
          "data-value": this.value
        });
      }

      if (this.className == 'transcript') {
        if (this.transcriptData) {
          return /*#__PURE__*/_react.default.createElement("a", {
            className: this.className,
            href: "javascript:void(0)",
            onClick: this.openTranscript
          });
        }

        return null;
      }

      return /*#__PURE__*/_react.default.createElement("span", {
        className: this.className
      });
    }
  }, {
    key: "openTranscript",
    value: function openTranscript(event) {
      event.preventDefault();
      var vp = $('.video-player')[0];

      require('TranscriptPopup').show(this.transcriptData.title, this.transcriptData.transcript, vp);
    }
  }]);
  return InfoItem;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "metadataFetch", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "value", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "transcriptData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "openTranscript", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "openTranscript"), _class.prototype)), _class);
var ObjectDetailBarBase = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(ObjectDetailBarBase, _Component2);

  var _super2 = _createSuper(ObjectDetailBarBase);

  function ObjectDetailBarBase() {
    var _this4;

    babelHelpers.classCallCheck(this, ObjectDetailBarBase);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this4, "typeName", _descriptor5, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "title", _descriptor6, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "purchaseAreaInfo", _descriptor7, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "headline", _descriptor8, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "features", _descriptor9, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "headlineText", _descriptor10, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "hasSponsor", _descriptor11, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "sponsor", _descriptor12, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "sponsorTitle", _descriptor13, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "discussionRoot", _descriptor14, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "infoList", _descriptor15, babelHelpers.assertThisInitialized(_this4));
    _this4.state = {
      purchaseAreaInfo: _this4.purchaseAreaInfo,
      activeTab: 0,
      dropdownOpen: false,
      dropdownLeft: false
    };
    return _this4;
  }

  babelHelpers.createClass(ObjectDetailBarBase, [{
    key: "selectPurchaseTab",
    value: function selectPurchaseTab(event) {
      this.setState({
        activeTab: event.target.dataset.purchaseTab
      });
    }
  }, {
    key: "selectPurchasedItem",
    value: function selectPurchasedItem(event) {
      if (this.state.purchaseAreaInfo.buttonAction) this.state.purchaseAreaInfo.buttonAction(event, this.state.activeTab);
    }
  }, {
    key: "doPromoCode",
    value: function doPromoCode(event) {
      event.preventDefault();

      if (this.state.purchaseAreaInfo.promoLinkAction) {
        this.state.purchaseAreaInfo.promoLinkAction(event);
      } else {
        if (!this.state.purchaseAreaInfo.usedPromoCode) {
          var pcm = new _PromotionCode.default(this.state.purchaseAreaInfo.id);
          pcm.show();
        } else {
          (0, _fetch.default)("data/promo-code/remove", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: '{}'
          }).then(function () {
            (0, _noty.showNotificationText)('Your code has been removed.');
            (0, _userProfile.userProfileUpdated)();
          });
        }
      }
    }
  }, {
    key: "share",
    value: function share() {
      Share.showShareDialog();
    }
  }, {
    key: "favorite",
    value: function favorite() {
      var _this5 = this;

      Bookmark.toggle().then(function () {
        return _this5.profileUpdated();
      });
    }
  }, {
    key: "report",
    value: function report() {
      // event.preventDefault();
      this.state.discussion.leaveReportResponse(null);
    }
  }, {
    key: "showSurvey",
    value: function showSurvey(event) {
      event.preventDefault();
      this.state.discussion.leaveSurveyResponse( /*#__PURE__*/_react.default.createElement(_SubmissionInfoBar.SurveyHeader, {
        callToAction: this.state.discussionRoot.node.survey.callToAction,
        catalogItem: this.state.purchaseAreaInfo.catalogItem
      }));
    }
  }, {
    key: "showApplication",
    value: function showApplication(event) {
      if (event) event.preventDefault();

      var r = _Discussion.default.createNewApplication( /*#__PURE__*/_react.default.createElement(_SubmissionInfoBar.SurveyHeader, {
        callToAction: this.state.purchaseAreaInfo.applicationHeaderText || this.state.purchaseAreaInfo.applicationCallToAction,
        catalogItem: this.state.purchaseAreaInfo.catalogItem
      }), this.state.purchaseAreaInfo.attachApplicationSurveyButton, this.state.purchaseAreaInfo.catalogItem.id, this.props.isScholarshipApplication);

      return event ? null : r;
    }
  }, {
    key: "buttonClicked",
    value: function buttonClicked(event) {
      if (this.state.purchaseAreaInfo.buttonAction) this.state.purchaseAreaInfo.buttonAction(event);
    }
  }, {
    key: "doRefreshTimer",
    value: function doRefreshTimer(period) {
      if (this._refreshTimer) {
        clearTimeout(this._refreshTimer);
      }

      ;

      if (period > 0x7fffffff) {
        this._timerPeriod = period;
        this._timerStartedAt = Date.now();
        this._refreshTimer = setTimeout(this._continueTimer, 0x7fffffff);
      } else {
        this._refreshTimer = setTimeout(this.doRefresh, period);
      }
    }
  }, {
    key: "_continueTimer",
    value: function _continueTimer() {
      var elapsed = Date.now() - this._timerStartedAt;

      var period = this._timerPeriod - elapsed;

      if (period > 0x7fffffff) {
        this._refreshTimer = setTimeout(this._continueTimer, 0x7fffffff);
      } else {
        this._refreshTimer = setTimeout(this.doRefresh, period);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this6 = this;

      $(document).on('profileUpdated courseStatusUpdated sitePropsUpdated', this.profileUpdated);

      if (this.discussionRoot) {
        _Discussion.default.getDiscussion(this.discussionRoot).then(function (discussion) {
          discussion.getDiscussionRoot().then(function (discussionRoot) {
            _this6.setState({
              discussion: discussion,
              discussionRoot: discussionRoot
            });
          });
        });
      }

      if (this.state.purchaseAreaInfo.autoRefresh) {
        var ts = this.state.purchaseAreaInfo.autoRefresh - Date.now();
        this.doRefreshTimer(ts);
      }

      if (this.state.purchaseAreaInfo.onMounted && typeof this.state.purchaseAreaInfo.onMounted == 'function') this.state.purchaseAreaInfo.onMounted();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this7 = this;

      if (prevProps.discussionRoot != this.props.discussionRoot && (this.state.discussionRoot || {
        node: {
          id: null
        }
      }).node.id != this.discussionRoot) {
        _Discussion.default.getDiscussion(this.discussionRoot).then(function (discussion) {
          discussion.getDiscussionRoot().then(function (discussionRoot) {
            _this7.setState({
              discussion: discussion,
              discussionRoot: discussionRoot
            });
          });
        });
      }

      if (this.state.dropdownOpen) {
        document.documentElement.addEventListener('click', this.handleBodyClick);
      } else {
        document.documentElement.removeEventListener('click', this.handleBodyClick);
      }

      clearTimeout(this._refreshTimer);

      if (this.state.purchaseAreaInfo.autoRefresh) {
        this.doRefreshTimer(this.state.purchaseAreaInfo.autoRefresh - Date.now());
      }

      if (this.props.purchaseAreaInfo != prevProps.purchaseAreaInfo) {
        this.setState({
          purchaseAreaInfo: this.props.purchaseAreaInfo
        });
      }

      if (this.state.purchaseAreaInfo != prevState.purchaseAreaInfo) {
        if (prevState && prevState.purchaseAreaInfo && prevState.purchaseAreaInfo.onUnmounted && typeof prevState.purchaseAreaInfo.onUnmounted == 'function') prevState.purchaseAreaInfo.onUnmounted();
        if (this.state.purchaseAreaInfo.onMounted && typeof this.state.purchaseAreaInfo.onMounted == 'function') this.state.purchaseAreaInfo.onMounted();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated courseStatusUpdated sitePropsUpdated', this.profileUpdated);
      clearTimeout(this._refreshTimer);

      if (this.state.dropdownOpen) {
        document.documentElement.removeEventListener('click', this.handleBodyClick);
      }

      if (this.state.purchaseAreaInfo.onUnmounted && typeof this.state.purchaseAreaInfo.onUnmounted == 'function') this.state.purchaseAreaInfo.onUnmounted();
    }
  }, {
    key: "doRefresh",
    value: function doRefresh() {
      (0, _userProfile.userProfileUpdated)();
    }
  }, {
    key: "handleBodyClick",
    value: function handleBodyClick(event) {
      if (this.state.dropdownOpen) {
        this.setState({
          dropdownOpen: false
        }); // event.stopPropagation();
      }
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(event) {
      if (document.documentElement.contains(_reactDom.default.findDOMNode(this))) {
        return;
      } else {
        if (!_reactDom.default.findDOMNode(this)) return;

        _reactDom.default.unmountComponentAtNode(_reactDom.default.findDOMNode(this));
      }
    }
  }]);
  return ObjectDetailBarBase;
}(_react.Component), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "typeName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "purchaseAreaInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "headline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "features", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "headlineText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "hasSponsor", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "sponsor", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "sponsorTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "infoList", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "selectPurchaseTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "selectPurchaseTab"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "selectPurchasedItem", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "selectPurchasedItem"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "doPromoCode", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "doPromoCode"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "share", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "share"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "favorite", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "favorite"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "report", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "report"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "showSurvey", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "showSurvey"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "showApplication", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "showApplication"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "buttonClicked", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "buttonClicked"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_continueTimer", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_continueTimer"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "doRefresh", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "doRefresh"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "handleBodyClick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "handleBodyClick"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdated"), _class3.prototype)), _class3);
var ActionButton = (_class5 = /*#__PURE__*/function (_Component3) {
  babelHelpers.inherits(ActionButton, _Component3);

  var _super3 = _createSuper(ActionButton);

  function ActionButton() {
    var _this8;

    babelHelpers.classCallCheck(this, ActionButton);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this8 = _super3.call.apply(_super3, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this8, "enabled", _descriptor16, babelHelpers.assertThisInitialized(_this8));
    babelHelpers.initializerDefineProperty(_this8, "action", _descriptor17, babelHelpers.assertThisInitialized(_this8));
    babelHelpers.initializerDefineProperty(_this8, "icon", _descriptor18, babelHelpers.assertThisInitialized(_this8));
    babelHelpers.initializerDefineProperty(_this8, "onClick", _descriptor19, babelHelpers.assertThisInitialized(_this8));
    return _this8;
  }

  babelHelpers.createClass(ActionButton, [{
    key: "render",
    value: function render() {
      return this.enabled ? /*#__PURE__*/_react.default.createElement("button", {
        className: "action-btn",
        "data-action": this.action,
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": this.icon
      })) : null;
    }
  }]);
  return ActionButton;
}(_react.Component), (_descriptor16 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "enabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "action", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "icon", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "onClick", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
var ShareButton = (_class7 = /*#__PURE__*/function (_Component4) {
  babelHelpers.inherits(ShareButton, _Component4);

  var _super4 = _createSuper(ShareButton);

  function ShareButton() {
    var _this9;

    babelHelpers.classCallCheck(this, ShareButton);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this9 = _super4.call.apply(_super4, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this9, "enabled", _descriptor20, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "share", _descriptor21, babelHelpers.assertThisInitialized(_this9));
    return _this9;
  }

  babelHelpers.createClass(ShareButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(ActionButton, {
        enabled: this.enabled,
        action: "share",
        icon: "share",
        onClick: this.share
      });
    }
  }]);
  return ShareButton;
}(_react.Component), (_descriptor20 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "enabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "share", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);
var FavoriteButton = (_class9 = /*#__PURE__*/function (_Component5) {
  babelHelpers.inherits(FavoriteButton, _Component5);

  var _super5 = _createSuper(FavoriteButton);

  function FavoriteButton() {
    var _this10;

    babelHelpers.classCallCheck(this, FavoriteButton);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this10 = _super5.call.apply(_super5, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this10, "enabled", _descriptor22, babelHelpers.assertThisInitialized(_this10));
    babelHelpers.initializerDefineProperty(_this10, "favorite", _descriptor23, babelHelpers.assertThisInitialized(_this10));
    babelHelpers.initializerDefineProperty(_this10, "isFavorite", _descriptor24, babelHelpers.assertThisInitialized(_this10));
    return _this10;
  }

  babelHelpers.createClass(FavoriteButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(ActionButton, {
        enabled: this.enabled,
        action: "favorite",
        icon: this.isFavorite ? 'favorite' : 'favorite_border',
        onClick: this.favorite
      });
    }
  }]);
  return FavoriteButton;
}(_react.Component), (_descriptor22 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "enabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "favorite", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "isFavorite", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);
var ReportDropdown = (_class11 = /*#__PURE__*/function (_Component6) {
  babelHelpers.inherits(ReportDropdown, _Component6);

  var _super6 = _createSuper(ReportDropdown);

  function ReportDropdown() {
    var _this11;

    babelHelpers.classCallCheck(this, ReportDropdown);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this11 = _super6.call.apply(_super6, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this11, "discussionRoot", _descriptor25, babelHelpers.assertThisInitialized(_this11));
    babelHelpers.initializerDefineProperty(_this11, "report", _descriptor26, babelHelpers.assertThisInitialized(_this11));
    _this11.state = {
      dropdownOpen: false,
      dropdownLeft: false
    };
    return _this11;
  }

  babelHelpers.createClass(ReportDropdown, [{
    key: "toggleDropdown",
    value: function toggleDropdown(event) {
      var _this12 = this;

      this.setState(function (st) {
        return {
          dropdownLeft: false,
          dropdownOpen: !_this12.state.dropdownOpen
        };
      }, function () {
        if (_this12.state.dropdownOpen && _this12._dropdown) {
          var br = _this12._dropdown.getBoundingClientRect();

          if (br.left < 0) _this12.setState({
            dropdownLeft: true
          });
        }
      });
      event.stopPropagation();
    }
  }, {
    key: "gotDropdown",
    value: function gotDropdown(node) {
      this._dropdown = node;
    }
  }, {
    key: "doReport",
    value: function doReport() {
      this.setState({
        dropdownOpen: false
      });
      this.report();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.discussionRoot && this.discussionRoot.node.report) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: _classList.default.join('dropdown', this.state.dropdownOpen && 'open')
        }, /*#__PURE__*/_react.default.createElement(ActionButton, {
          enabled: true,
          action: "menu",
          icon: "more_vert",
          onClick: this.toggleDropdown
        }), /*#__PURE__*/_react.default.createElement("ul", {
          className: _classList.default.join('dropdown-menu', !this.state.dropdownLeft && 'dropdown-menu-right'),
          ref: this.gotDropdown
        }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
          href: "javascript:void(0)",
          onClick: this.doReport
        }, "Report"))));
      }

      return null;
    }
  }]);
  return ReportDropdown;
}(_react.Component), (_descriptor25 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "report", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class11.prototype, "toggleDropdown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class11.prototype, "toggleDropdown"), _class11.prototype), babelHelpers.applyDecoratedDescriptor(_class11.prototype, "gotDropdown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class11.prototype, "gotDropdown"), _class11.prototype), babelHelpers.applyDecoratedDescriptor(_class11.prototype, "doReport", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class11.prototype, "doReport"), _class11.prototype)), _class11);
var MaybeContainer = (_class13 = /*#__PURE__*/function (_Component7) {
  babelHelpers.inherits(MaybeContainer, _Component7);

  var _super7 = _createSuper(MaybeContainer);

  function MaybeContainer() {
    var _this13;

    babelHelpers.classCallCheck(this, MaybeContainer);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this13 = _super7.call.apply(_super7, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this13, "exposed", _descriptor27, babelHelpers.assertThisInitialized(_this13));
    return _this13;
  }

  babelHelpers.createClass(MaybeContainer, [{
    key: "render",
    value: function render() {
      if (this.exposed) {
        var _this$props = this.props,
            tagName = _this$props.tagName,
            exposed = _this$props.exposed,
            props = babelHelpers.objectWithoutProperties(_this$props, _excluded2);
        return /*#__PURE__*/_react.default.createElement(tagName, props);
      }

      return null;
    }
  }]);
  return MaybeContainer;
}(_react.Component), (_descriptor27 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "exposed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class13);
var Sponsor = (_class15 = /*#__PURE__*/function (_Component8) {
  babelHelpers.inherits(Sponsor, _Component8);

  var _super8 = _createSuper(Sponsor);

  function Sponsor() {
    var _this14;

    babelHelpers.classCallCheck(this, Sponsor);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this14 = _super8.call.apply(_super8, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this14, "hasSponsor", _descriptor28, babelHelpers.assertThisInitialized(_this14));
    babelHelpers.initializerDefineProperty(_this14, "sponsor", _descriptor29, babelHelpers.assertThisInitialized(_this14));
    babelHelpers.initializerDefineProperty(_this14, "sponsorTitle", _descriptor30, babelHelpers.assertThisInitialized(_this14));
    return _this14;
  }

  babelHelpers.createClass(Sponsor, [{
    key: "render",
    value: function render() {
      return this.hasSponsor && this.sponsor ? /*#__PURE__*/_react.default.createElement("div", {
        className: "sponsor"
      }, /*#__PURE__*/_react.default.createElement("h4", null, this.sponsorTitle || 'Brought to you by'), /*#__PURE__*/_react.default.createElement(MaybeLink, {
        linked: {
          component: 'a',
          className: 'sponsor-link',
          target: this.sponsor.openInNewWindow ? '_blank' : '_self'
        },
        unlinked: {
          component: 'span',
          className: 'sponsor-link unlinked'
        },
        href: this.sponsor.link
      }, this.sponsor.logo && /*#__PURE__*/_react.default.createElement("span", {
        className: "sponsor-logo",
        title: this.sponsor.title,
        style: {
          backgroundImage: "url(".concat(this.sponsor.logo, ")")
        }
      }), !this.sponsor.logo && /*#__PURE__*/_react.default.createElement("span", {
        className: "sponsor-name"
      }, this.sponsor.title))) : null;
    }
  }]);
  return Sponsor;
}(_react.Component), (_descriptor28 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "hasSponsor", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "sponsor", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "sponsorTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Brought to you by';
  }
})), _class15);
var Feature = (_class17 = /*#__PURE__*/function (_Component9) {
  babelHelpers.inherits(Feature, _Component9);

  var _super9 = _createSuper(Feature);

  function Feature() {
    var _this15;

    babelHelpers.classCallCheck(this, Feature);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this15 = _super9.call.apply(_super9, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this15, "feature", _descriptor31, babelHelpers.assertThisInitialized(_this15));
    return _this15;
  }

  babelHelpers.createClass(Feature, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "feature"
      }, /*#__PURE__*/_react.default.createElement("header", null, this.feature.image_name && /*#__PURE__*/_react.default.createElement("div", {
        className: "feature-icon",
        style: {
          backgroundImage: "url(".concat(this.feature.image_name, ")")
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('feature-title', !this.feature.image_name && 'no-image')
      }, this.feature.title)), /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('feature-body', !this.feature.image_name && 'no-image'),
        dangerouslySetInnerHTML: {
          __html: feature.summary
        }
      }));
    }
  }]);
  return Feature;
}(_react.Component), (_descriptor31 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "feature", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class17);
var Features = (_class19 = /*#__PURE__*/function (_Component10) {
  babelHelpers.inherits(Features, _Component10);

  var _super10 = _createSuper(Features);

  function Features() {
    var _this16;

    babelHelpers.classCallCheck(this, Features);

    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    _this16 = _super10.call.apply(_super10, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this16, "features", _descriptor32, babelHelpers.assertThisInitialized(_this16));
    return _this16;
  }

  babelHelpers.createClass(Features, [{
    key: "render",
    value: function render() {
      return this.features && this.features.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "features"
      }, this.features.map(function (feature) {
        return /*#__PURE__*/_react.default.createElement(Feature, {
          feature: feature,
          key: feature.id
        });
      })) : null;
    }
  }]);
  return Features;
}(_react.Component), (_descriptor32 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "features", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class19);
var Headline = (_class21 = /*#__PURE__*/function (_Component11) {
  babelHelpers.inherits(Headline, _Component11);

  var _super11 = _createSuper(Headline);

  function Headline() {
    var _this17;

    babelHelpers.classCallCheck(this, Headline);

    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    _this17 = _super11.call.apply(_super11, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this17, "textIsHeader", _descriptor33, babelHelpers.assertThisInitialized(_this17));
    babelHelpers.initializerDefineProperty(_this17, "textIsComponent", _descriptor34, babelHelpers.assertThisInitialized(_this17));
    babelHelpers.initializerDefineProperty(_this17, "text", _descriptor35, babelHelpers.assertThisInitialized(_this17));
    babelHelpers.initializerDefineProperty(_this17, "typeName", _descriptor36, babelHelpers.assertThisInitialized(_this17));
    babelHelpers.initializerDefineProperty(_this17, "headline", _descriptor37, babelHelpers.assertThisInitialized(_this17));
    return _this17;
  }

  babelHelpers.createClass(Headline, [{
    key: "render",
    value: function render() {
      if (this.textIsComponent) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "item-header-content"
        }, /*#__PURE__*/_react.default.createElement(require(this.text.component)[this.text.name || 'default'], this.text));
      }

      if (this.textIsHeader) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "item-header-content",
          dangerouslySetInnerHTML: {
            __html: this.text
          }
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "standard-item-header-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        key: "type-name",
        "data-type": this.typeName,
        className: "type-name"
      }), /*#__PURE__*/_react.default.createElement("h1", {
        key: "headline",
        className: "headline"
      }, this.headline), /*#__PURE__*/_react.default.createElement("h2", {
        key: "summary",
        className: "summary"
      }, this.summary));
    }
  }]);
  return Headline;
}(_react.Component), (_descriptor33 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "textIsHeader", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor34 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "textIsComponent", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor35 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "text", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "typeName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "headline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class21);
var ObjectDetailTab = (_class23 = /*#__PURE__*/function (_Component12) {
  babelHelpers.inherits(ObjectDetailTab, _Component12);

  var _super12 = _createSuper(ObjectDetailTab);

  function ObjectDetailTab() {
    var _this18;

    babelHelpers.classCallCheck(this, ObjectDetailTab);

    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    _this18 = _super12.call.apply(_super12, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this18, "selectTab", _descriptor38, babelHelpers.assertThisInitialized(_this18));
    babelHelpers.initializerDefineProperty(_this18, "enabled", _descriptor39, babelHelpers.assertThisInitialized(_this18));
    babelHelpers.initializerDefineProperty(_this18, "tabTitle", _descriptor40, babelHelpers.assertThisInitialized(_this18));
    babelHelpers.initializerDefineProperty(_this18, "children", _descriptor41, babelHelpers.assertThisInitialized(_this18));
    babelHelpers.initializerDefineProperty(_this18, "active", _descriptor42, babelHelpers.assertThisInitialized(_this18));
    return _this18;
  }

  babelHelpers.createClass(ObjectDetailTab, [{
    key: "render",
    value: function render() {
      if (!this.props.children) return /*#__PURE__*/_react.default.createElement("div", null, "Nothing here?");
      return _react.default.Children.only(this.props.children);
    }
  }], [{
    key: "getProps",
    value: function getProps(props) {
      return props;
    }
  }]);
  return ObjectDetailTab;
}(_react.Component), (_descriptor38 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "selectTab", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "enabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "tabTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "active", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class23);
var TabBar = (_class25 = /*#__PURE__*/function (_Component13) {
  babelHelpers.inherits(TabBar, _Component13);

  var _super13 = _createSuper(TabBar);

  function TabBar() {
    var _this19;

    babelHelpers.classCallCheck(this, TabBar);

    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }

    _this19 = _super13.call.apply(_super13, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this19, "content", _descriptor43, babelHelpers.assertThisInitialized(_this19));
    return _this19;
  }

  babelHelpers.createClass(TabBar, [{
    key: "render",
    value: function render() {
      return this.content && this.content.length > 1 ? /*#__PURE__*/_react.default.createElement("ul", {
        className: "nav nav-tabs"
      }, this.content.map(function (tab, index) {
        return /*#__PURE__*/_react.default.createElement(Tab, {
          tabInfo: tab,
          key: index
        });
      })) : null;
    }
  }]);
  return TabBar;
}(_react.Component), (_descriptor43 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class25);
var TabInner = (_class27 = /*#__PURE__*/function (_Component14) {
  babelHelpers.inherits(TabInner, _Component14);

  var _super14 = _createSuper(TabInner);

  function TabInner() {
    var _this20;

    babelHelpers.classCallCheck(this, TabInner);

    for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      args[_key14] = arguments[_key14];
    }

    _this20 = _super14.call.apply(_super14, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this20, "active", _descriptor44, babelHelpers.assertThisInitialized(_this20));
    babelHelpers.initializerDefineProperty(_this20, "enabled", _descriptor45, babelHelpers.assertThisInitialized(_this20));
    babelHelpers.initializerDefineProperty(_this20, "selectTab", _descriptor46, babelHelpers.assertThisInitialized(_this20));
    babelHelpers.initializerDefineProperty(_this20, "tabTitle", _descriptor47, babelHelpers.assertThisInitialized(_this20));
    babelHelpers.initializerDefineProperty(_this20, "dataSet", _descriptor48, babelHelpers.assertThisInitialized(_this20));
    return _this20;
  }

  babelHelpers.createClass(TabInner, [{
    key: "render",
    value: function render() {
      var _this21 = this;

      var ds = {};

      var fixKey = function fixKey(k) {
        return "data-".concat(k.replace(/[A-Z]/g, function (ch) {
          return '-' + ch.toLowerCase();
        }));
      };

      Object.keys(this.dataSet).forEach(function (k) {
        return ds[fixKey(k)] = _this21.dataSet[k];
      });
      return /*#__PURE__*/_react.default.createElement("li", {
        className: _classList.default.join(this.active && 'active')
      }, /*#__PURE__*/_react.default.createElement("a", _extends({
        href: "javascript:void(0)",
        className: _classList.default.join(!this.enabled && 'disabled'),
        onClick: this.selectTab
      }, ds), this.tabTitle));
    }
  }]);
  return TabInner;
}(_react.Component), (_descriptor44 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "active", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "enabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "selectTab", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "tabTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "dataSet", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class27);
var Tab = (_class29 = /*#__PURE__*/function (_Component15) {
  babelHelpers.inherits(Tab, _Component15);

  var _super15 = _createSuper(Tab);

  function Tab() {
    var _this22;

    babelHelpers.classCallCheck(this, Tab);

    for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      args[_key15] = arguments[_key15];
    }

    _this22 = _super15.call.apply(_super15, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this22, "tabInfo", _descriptor49, babelHelpers.assertThisInitialized(_this22));
    return _this22;
  }

  babelHelpers.createClass(Tab, [{
    key: "render",
    value: function render() {
      var props = this.tabInfo.type.getProps(this.tabInfo.props);
      return /*#__PURE__*/_react.default.createElement(TabInner, props);
    }
  }]);
  return Tab;
}(_react.Component), (_descriptor49 = babelHelpers.applyDecoratedDescriptor(_class29.prototype, "tabInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class29);
var TabContent = (_class31 = /*#__PURE__*/function (_Component16) {
  babelHelpers.inherits(TabContent, _Component16);

  var _super16 = _createSuper(TabContent);

  function TabContent() {
    var _this23;

    babelHelpers.classCallCheck(this, TabContent);

    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }

    _this23 = _super16.call.apply(_super16, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this23, "content", _descriptor50, babelHelpers.assertThisInitialized(_this23));
    return _this23;
  }

  babelHelpers.createClass(TabContent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tab-content"
      }, this.content.map(function (tab, index) {
        return /*#__PURE__*/_react.default.createElement(TabPane, {
          tabInfo: tab,
          key: index
        });
      }));
    }
  }]);
  return TabContent;
}(_react.Component), (_descriptor50 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class31);
var TabPane = (_class33 = /*#__PURE__*/function (_Component17) {
  babelHelpers.inherits(TabPane, _Component17);

  var _super17 = _createSuper(TabPane);

  function TabPane() {
    var _this24;

    babelHelpers.classCallCheck(this, TabPane);

    for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      args[_key17] = arguments[_key17];
    }

    _this24 = _super17.call.apply(_super17, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this24, "tabInfo", _descriptor51, babelHelpers.assertThisInitialized(_this24));
    return _this24;
  }

  babelHelpers.createClass(TabPane, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('tab-pane', this.tabInfo.props.active && 'active')
      }, this.tabInfo);
    }
  }]);
  return TabPane;
}(_react.Component), (_descriptor51 = babelHelpers.applyDecoratedDescriptor(_class33.prototype, "tabInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class33);

var ObjectDetailTabs = /*#__PURE__*/function (_Component18) {
  babelHelpers.inherits(ObjectDetailTabs, _Component18);

  var _super18 = _createSuper(ObjectDetailTabs);

  function ObjectDetailTabs() {
    babelHelpers.classCallCheck(this, ObjectDetailTabs);
    return _super18.apply(this, arguments);
  }

  babelHelpers.createClass(ObjectDetailTabs, [{
    key: "render",
    value: function render() {
      var children = _react.default.Children.toArray(this.props.children); // children = children.filter(element => element.type == ObjectDetailTab);


      return children.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "collection-purchase-info"
      }, /*#__PURE__*/_react.default.createElement(TabBar, {
        content: children
      }), /*#__PURE__*/_react.default.createElement(TabContent, {
        content: children
      })) : null;
    }
  }]);
  return ObjectDetailTabs;
}(_react.Component);

var PromoCodeLink = (_class35 = /*#__PURE__*/function (_Component19) {
  babelHelpers.inherits(PromoCodeLink, _Component19);

  var _super19 = _createSuper(PromoCodeLink);

  function PromoCodeLink() {
    var _this25;

    babelHelpers.classCallCheck(this, PromoCodeLink);

    for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
      args[_key18] = arguments[_key18];
    }

    _this25 = _super19.call.apply(_super19, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this25, "price", _descriptor52, babelHelpers.assertThisInitialized(_this25));
    babelHelpers.initializerDefineProperty(_this25, "onClick", _descriptor53, babelHelpers.assertThisInitialized(_this25));
    babelHelpers.initializerDefineProperty(_this25, "used", _descriptor54, babelHelpers.assertThisInitialized(_this25));
    babelHelpers.initializerDefineProperty(_this25, "enabled", _descriptor55, babelHelpers.assertThisInitialized(_this25));
    babelHelpers.initializerDefineProperty(_this25, "specifiedText", _descriptor56, babelHelpers.assertThisInitialized(_this25));
    return _this25;
  }

  babelHelpers.createClass(PromoCodeLink, [{
    key: "render",
    value: function render() {
      if (this.enabled && (this.specifiedText || this.price != '$0' && this.price)) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "promoLink"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "javascript:void(0)",
          onClick: this.onClick
        }, this.specifiedText ? this.specifiedText : this.used ? 'Remove discount code' : 'Have a discount code?'));
      }

      return null;
    }
  }]);
  return PromoCodeLink;
}(_react.Component), (_descriptor52 = babelHelpers.applyDecoratedDescriptor(_class35.prototype, "price", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = babelHelpers.applyDecoratedDescriptor(_class35.prototype, "onClick", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = babelHelpers.applyDecoratedDescriptor(_class35.prototype, "used", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = babelHelpers.applyDecoratedDescriptor(_class35.prototype, "enabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor56 = babelHelpers.applyDecoratedDescriptor(_class35.prototype, "specifiedText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class35);

var PromoText = function PromoText(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "promoLink text"
  }, /*#__PURE__*/_react.default.createElement("span", null, text));
};

var PurchaseTab = (_class37 = /*#__PURE__*/function (_ObjectDetailTab) {
  babelHelpers.inherits(PurchaseTab, _ObjectDetailTab);

  var _super20 = _createSuper(PurchaseTab);

  function PurchaseTab() {
    var _this26;

    babelHelpers.classCallCheck(this, PurchaseTab);

    for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
      args[_key19] = arguments[_key19];
    }

    _this26 = _super20.call.apply(_super20, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this26, "option", _descriptor57, babelHelpers.assertThisInitialized(_this26));
    babelHelpers.initializerDefineProperty(_this26, "purchaseAreaInfo", _descriptor58, babelHelpers.assertThisInitialized(_this26));
    babelHelpers.initializerDefineProperty(_this26, "index", _descriptor59, babelHelpers.assertThisInitialized(_this26));
    babelHelpers.initializerDefineProperty(_this26, "selectPurchasedItem", _descriptor60, babelHelpers.assertThisInitialized(_this26));
    babelHelpers.initializerDefineProperty(_this26, "doPromoCode", _descriptor61, babelHelpers.assertThisInitialized(_this26));
    return _this26;
  }

  babelHelpers.createClass(PurchaseTab, [{
    key: "render",
    value: function render() {
      var index = this.index,
          option = this.option,
          purchaseAreaInfo = this.purchaseAreaInfo,
          selectPurchasedItem = this.selectPurchasedItem,
          doPromoCode = this.doPromoCode;
      return /*#__PURE__*/_react.default.createElement("div", null, option.discount && option.discount.basePrice != '$0' && option.discount.basePrice != '$0.00' ? /*#__PURE__*/_react.default.createElement("div", {
        className: "discount"
      }, "Discount applied: ", /*#__PURE__*/_react.default.createElement("span", {
        className: "basePrice"
      }, option.discount.basePrice), " - ", option.discount.percentOff, "% off") : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: _classList.default.join('btn btn-primary buy-button', option.priceText == '$0' ? 'free-button' : '', !purchaseAreaInfo.buttonEnabled && 'disabled'),
        "data-index": index,
        onClick: purchaseAreaInfo.buttonEnabled ? selectPurchasedItem : NoOp
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "item-price"
      }, option.priceText), /*#__PURE__*/_react.default.createElement("span", {
        className: "purchase-action"
      }, option.priceText == '$0' && purchaseAreaInfo.buttonText == 'Buy Now' ? 'Register' : purchaseAreaInfo.buttonText || 'Buy Now'))), /*#__PURE__*/_react.default.createElement(PromoCodeLink, {
        enabled: purchaseAreaInfo.buttonEnabled,
        onClick: doPromoCode,
        used: purchaseAreaInfo.usedPromoCode,
        price: option.discount ? option.discount.basePrice : option.priceText
      }));
    }
  }], [{
    key: "getProps",
    value: function getProps(props) {
      return {
        tabTitle: props.option.tabTitle,
        enabled: props.purchaseAreaInfo.buttonEnabled,
        selectTab: props.purchaseAreaInfo.buttonEnabled ? props.selectTab : NoOp,
        active: props.active,
        dataSet: props.dataSet || {}
      };
    }
  }]);
  return PurchaseTab;
}(ObjectDetailTab), (_descriptor57 = babelHelpers.applyDecoratedDescriptor(_class37.prototype, "option", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = babelHelpers.applyDecoratedDescriptor(_class37.prototype, "purchaseAreaInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = babelHelpers.applyDecoratedDescriptor(_class37.prototype, "index", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = babelHelpers.applyDecoratedDescriptor(_class37.prototype, "selectPurchasedItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = babelHelpers.applyDecoratedDescriptor(_class37.prototype, "doPromoCode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class37);
var ObjectDetailPageHeader = (_class39 = /*#__PURE__*/function (_ObjectDetailBarBase) {
  babelHelpers.inherits(ObjectDetailPageHeader, _ObjectDetailBarBase);

  var _super21 = _createSuper(ObjectDetailPageHeader);

  function ObjectDetailPageHeader() {
    var _this27;

    babelHelpers.classCallCheck(this, ObjectDetailPageHeader);

    for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      args[_key20] = arguments[_key20];
    }

    _this27 = _super21.call.apply(_super21, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this27, "headlineTextIsHeader", _descriptor62, babelHelpers.assertThisInitialized(_this27));
    babelHelpers.initializerDefineProperty(_this27, "headlineTextIsComponent", _descriptor63, babelHelpers.assertThisInitialized(_this27));
    _this27.state = Object.assign(_this27.state, {
      activeTab: 0
    });
    return _this27;
  }

  babelHelpers.createClass(ObjectDetailPageHeader, [{
    key: "render",
    value: function render() {
      var _this28 = this;

      var p = Object.assign({
        buttonEnabled: true
      }, this.state.purchaseAreaInfo);
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement(Headline, {
        textIsHeader: this.headlineTextIsHeader,
        textIsComponent: this.headlineTextIsComponent,
        text: this.headlineText,
        typeName: this.typeName,
        headline: this.headline || this.title
      }), /*#__PURE__*/_react.default.createElement(ObjectDetailTabs, null, p && p.pricingOptions ? p.pricingOptions.map(function (option, index) {
        return /*#__PURE__*/_react.default.createElement(PurchaseTab, {
          active: _this28.state.activeTab == index,
          dataSet: {
            purchaseTab: index
          },
          option: option,
          index: index,
          purchaseAreaInfo: p,
          selectPurchasedItem: _this28.selectPurchasedItem,
          selectTab: _this28.selectPurchaseTab,
          key: index
        });
      }) : p && (p.additionalInformation || p.buttonText || false) ? /*#__PURE__*/_react.default.createElement(ObjectDetailTab, {
        tabTitle: "unused",
        active: true,
        enabled: true
      }, /*#__PURE__*/_react.default.createElement("div", null, p.additionalInformation ? /*#__PURE__*/_react.default.createElement("div", {
        className: "price"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "free-trial alert alert-success"
      }, p.additionalInformation)) : null, p.attachApplicationSurveyButton ? /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: _classList.default.join('btn btn-primary buy-button', !p.buttonEnabled && 'disabled'),
        href: "javascript:void(0)",
        onClick: p.buttonEnabled ? this.showApplication : NoOp
      }, p.priceText && /*#__PURE__*/_react.default.createElement("span", {
        className: "itemPrice"
      }, p.priceText), /*#__PURE__*/_react.default.createElement("span", {
        className: "purchase-action"
      }, p.applicationCallToAction))) : null, p.attachDiscussionSurveyButton && this.state.discussionRoot && this.state.discussionRoot.node.survey ? /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: _classList.default.join('btn btn-primary buy-button', !p.buttonEnabled && 'disabled'),
        href: "javascript:void(0)",
        onClick: p.buttonEnabled ? this.showSurvey : NoOp
      }, p.priceText && /*#__PURE__*/_react.default.createElement("span", {
        className: "itemPrice"
      }, p.priceText), /*#__PURE__*/_react.default.createElement("span", {
        className: "purchase-action"
      }, this.state.discussionRoot.node.survey.callToAction))) : null, !!p.buttonText && /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: _classList.default.join('btn btn-primary buy-button', !p.buttonEnabled && 'disabled'),
        href: p.buttonEnabled && p.buttonLink || 'javascript:void(0)',
        target: p.buttonEnabled && p.buttonLink && p.buttonNewWindow && '_blank' || void 0,
        "data-index": null,
        onClick: p.buttonEnabled ? p.buttonLink ? null : this.selectPurchasedItem : NoOp
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "purchase-action"
      }, p.buttonText))))) : null), /*#__PURE__*/_react.default.createElement(MaybeContainer, {
        exposed: p.sharingEnabled || p.favoritesEnabled || this.state.discussionRoot && this.state.discussionRoot.node.report,
        tagName: "div",
        className: "actions"
      }, /*#__PURE__*/_react.default.createElement(ShareButton, {
        enabled: p.sharingEnabled,
        share: this.share
      }), /*#__PURE__*/_react.default.createElement(FavoriteButton, {
        enabled: p.favoritesEnabled,
        favorite: this.favorite,
        isFavorite: p.isFavorite
      }), /*#__PURE__*/_react.default.createElement(ReportDropdown, {
        discussionRoot: this.state.discussionRoot,
        report: this.report
      })), /*#__PURE__*/_react.default.createElement(Sponsor, {
        hasSponsor: this.hasSponsor,
        sponsor: this.sponsor,
        sponsorTitle: this.sponsorTitle
      }), (this.purchaseAreaInfo.additionalComponents || []).map(function (_ref2, index) {
        var module = _ref2.module,
            name = _ref2.name,
            props = _ref2.props;

        var m = require(module);

        var Item = m[name || 'default'];
        return /*#__PURE__*/_react.default.createElement(Item, _extends({
          key: index
        }, props));
      })), /*#__PURE__*/_react.default.createElement(Features, {
        features: this.features
      }));
    }
  }]);
  return ObjectDetailPageHeader;
}(ObjectDetailBarBase), (_descriptor62 = babelHelpers.applyDecoratedDescriptor(_class39.prototype, "headlineTextIsHeader", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor63 = babelHelpers.applyDecoratedDescriptor(_class39.prototype, "headlineTextIsComponent", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class39);
exports.ObjectDetailPageHeader = ObjectDetailPageHeader;
var PurchaseButton = (_class41 = /*#__PURE__*/function (_Component20) {
  babelHelpers.inherits(PurchaseButton, _Component20);

  var _super22 = _createSuper(PurchaseButton);

  function PurchaseButton() {
    var _this29;

    babelHelpers.classCallCheck(this, PurchaseButton);

    for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      args[_key21] = arguments[_key21];
    }

    _this29 = _super22.call.apply(_super22, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this29, "purchaseAreaInfo", _descriptor64, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "doPromoCode", _descriptor65, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "buttonClicked", _descriptor66, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "showSurvey", _descriptor67, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "showApplication", _descriptor68, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "discussionRoot", _descriptor69, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "promoText", _descriptor70, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "purchaseButtonTextOverride", _descriptor71, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "showPriceOverride", _descriptor72, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "showPromoOverride", _descriptor73, babelHelpers.assertThisInitialized(_this29));
    babelHelpers.initializerDefineProperty(_this29, "showMinimalPrice", _descriptor74, babelHelpers.assertThisInitialized(_this29));
    _this29.state = {
      discussion: null,
      discussionRoot: null,
      pending: true
    };
    return _this29;
  }

  babelHelpers.createClass(PurchaseButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate({}, {});
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this30 = this;

      if (prevProps.discussionRoot != this.props.discussionRoot && (this.state.discussionRoot || {
        node: {
          id: null
        }
      }).node.id != this.discussionRoot) {
        _Discussion.default.getDiscussion(this.discussionRoot).then(function (discussion) {
          discussion.getDiscussionRoot().then(function (discussionRoot) {
            _this30.setState({
              discussion: discussion,
              discussionRoot: discussionRoot
            });
          });
        });
      }

      if (prevProps.purchaseAreaInfo !== this.purchaseAreaInfo) {
        clearTimeout(this._timer);
        this.setState({
          pending: false
        });
      }
    }
  }, {
    key: "buttonAction",
    value: function buttonAction(event) {
      var _this31 = this;

      if (this.state.pending) {
        event.preventDefault();
        return;
      }

      var p = this.purchaseAreaInfo;

      if (p.attachApplicationSurveyButton) {
        if (p.buttonEnabled) this.showApplication(event);
      } else if (p.attachDiscussionSurveyButton) {
        if (this.state.discussionRoot && this.state.discussionRoot.node.survey) {
          this.showSurvey(event);
        }
      } else if (p.buttonLink || p.buttonAction || p.buttonDisabled) {
        if (this.buttonClicked) {
          this.buttonClicked(event);
          this._timer = setTimeout(function () {
            return _this31.setState({
              pending: false
            });
          }, 5000);
          this.setState({
            pending: true
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var p = this.purchaseAreaInfo;
      var showButton = false;
      var isBuyButton = false;
      var isEditButton = false;
      var isFreeButton = false;
      var buttonIsEnabled = true;
      var buttonLink = 'javascript:void(0)';
      var buttonTarget = void 0;
      var buttonOnClick = NoOp;
      var showPromo = null;
      var showSubtext = null;
      var itemPriceArea = null;
      var callToAction;
      var isPending = this.state.pending;
      var extraLinkProps = {};

      if (isPending) {
        extraLinkProps = {
          'data-spin': 'true'
        };
      }

      if (p.attachApplicationSurveyButton) {
        showButton = true;
        isBuyButton = true;
        buttonIsEnabled = !!p.buttonEnabled;
        if (buttonIsEnabled) buttonOnClick = this.showApplication;

        if (this.showPromoOverride !== false) {
          showPromo = /*#__PURE__*/_react.default.createElement(PromoCodeLink, {
            enabled: p.promoLinkAction || p.buttonIsPurchase,
            onClick: this.doPromoCode,
            used: p.promoLinkAction ? false : p.usedPromoCode,
            price: p.discount ? p.discount.basePrice : p.priceText,
            specifiedText: p.promoLinkText
          });
        }

        callToAction = p.applicationCallToAction;
      } else if (p.attachDiscussionSurveyButton) {
        if (this.state.discussionRoot && this.state.discussionRoot.node.survey) {
          showButton = true;
          buttonIsEnabled = !!p.buttonEnabled;
          if (buttonIsEnabled) buttonOnClick = this.showSurvey;

          if (this.showPromoOverride !== false) {
            showPromo = /*#__PURE__*/_react.default.createElement(PromoCodeLink, {
              enabled: p.promoLinkAction || p.buttonIsPurchase,
              onClick: this.doPromoCode,
              used: p.promoLinkAction ? false : p.usedPromoCode,
              price: p.discount ? p.discount.basePrice : p.priceText,
              specifiedText: p.promoLinkText
            });
          }

          callToAction = this.state.discussionRoot.node.survey.callToAction;
        }
      } else if (p.buttonLink || p.buttonAction || p.buttonDisabled) {
        showButton = true;
        isEditButton = p.buttonIsEdit;
        isFreeButton = p.priceText == '$0';
        buttonIsEnabled = p.buttonEnabled;
        if (buttonIsEnabled && p.buttonDisabled) buttonIsEnabled = false;
        buttonLink = buttonIsEnabled ? p.buttonLink : 'javascript:void(0)';
        buttonTarget = buttonIsEnabled && p.buttonNewWindow ? '_blank' : void 0;
        if (this.buttonClicked) buttonOnClick = this.buttonClicked;
        if (this.showMinimalPrice === false && this.purchaseAreaInfo.promoText) showSubtext = /*#__PURE__*/_react.default.createElement(PromoText, {
          text: this.purchaseAreaInfo.promoText
        });
        if ((p.model == 'not-available' || p.buttonIsPurchase) && this.purchaseButtonTextOverride !== null) callToAction = this.purchaseButtonTextOverride;else {
          callToAction = p.buttonText || 'Learn More';
        }

        if (this.showPromoOverride !== false) {
          showPromo = /*#__PURE__*/_react.default.createElement(PromoCodeLink, {
            enabled: p.promoLinkAction || p.buttonIsPurchase,
            onClick: this.doPromoCode,
            used: p.promoLinkAction ? false : p.usedPromoCode,
            price: p.discount ? p.discount.basePrice : p.priceText,
            specifiedText: p.promoLinkText
          });
        }
      }

      if (!showButton) {
        return null;
      }

      if (this.showMinimalPrice) {
        if (p.pricingOptions[0].firstPeriodDiscount) {
          itemPriceArea = /*#__PURE__*/_react.default.createElement("span", {
            className: "itemPrice"
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "strike"
          }, "$", p.pricingOptions[0].price), /*#__PURE__*/_react.default.createElement("span", null, "$", Number(p.pricingOptions[0].price) - p.pricingOptions[0].firstPeriodDiscount));
        } else {
          itemPriceArea = /*#__PURE__*/_react.default.createElement("span", {
            className: "itemPrice"
          }, "$", p.pricingOptions[0].price);
        }
      }

      if (!itemPriceArea) {
        if (p.priceText) {
          itemPriceArea = /*#__PURE__*/_react.default.createElement("span", {
            className: "itemPrice"
          }, p.priceText);
        }
      }

      if (this.showPriceOverride === false) itemPriceArea = null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase-button primary-purchase-button"
      }, /*#__PURE__*/_react.default.createElement("a", _extends({
        className: _classList.default.join('btn', 'btn-primary', isPending && 'spinning', isBuyButton && 'buy-button', isFreeButton && 'free-button', !buttonIsEnabled && 'disabled')
      }, extraLinkProps, {
        href: buttonLink,
        target: buttonTarget,
        onClick: buttonOnClick == NoOp ? NoOp : this.buttonAction
      }), itemPriceArea, /*#__PURE__*/_react.default.createElement("span", {
        className: "purchase-action"
      }, callToAction)), showPromo, showSubtext);
    }
  }]);
  return PurchaseButton;
}(_react.Component), (_descriptor64 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "purchaseAreaInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "doPromoCode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "buttonClicked", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "showSurvey", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "showApplication", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "promoText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor71 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "purchaseButtonTextOverride", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor72 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "showPriceOverride", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor73 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "showPromoOverride", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor74 = babelHelpers.applyDecoratedDescriptor(_class41.prototype, "showMinimalPrice", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class41.prototype, "buttonAction", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class41.prototype, "buttonAction"), _class41.prototype)), _class41);

var ObjectDetailInfoBar = /*#__PURE__*/function (_ObjectDetailBarBase2) {
  babelHelpers.inherits(ObjectDetailInfoBar, _ObjectDetailBarBase2);

  var _super23 = _createSuper(ObjectDetailInfoBar);

  function ObjectDetailInfoBar() {
    babelHelpers.classCallCheck(this, ObjectDetailInfoBar);
    return _super23.apply(this, arguments);
  }

  babelHelpers.createClass(ObjectDetailInfoBar, [{
    key: "render",
    value: function render() {
      var p = Object.assign({
        buttonEnabled: true
      }, this.state.purchaseAreaInfo);
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", {
        className: _classList.default.join('title', 'object-type', this.typeName, this.infoList.length ? 'has-info' : '')
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "object-title"
      }, this.title), this.infoList.length ? /*#__PURE__*/_react.default.createElement("span", {
        className: "info-items"
      }, this.infoList.map(function (info, index) {
        return /*#__PURE__*/_react.default.createElement(InfoItem, _extends({
          key: index
        }, info));
      })) : null), p ? /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase-info"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase-button-container"
      }, p.additionalInformation ? /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase-text",
        dangerouslySetInnerHTML: {
          __html: p.additionalInformation
        }
      }) : null, p.buttonIsPurchase && p.discount && p.discount.basePrice != '$0' && /*#__PURE__*/_react.default.createElement("div", {
        className: "purchase-price"
      }, p.discount && /*#__PURE__*/_react.default.createElement("div", {
        className: "discount"
      }, "Discount applied: ", /*#__PURE__*/_react.default.createElement("span", {
        className: "basePrice"
      }, p.discount.basePrice), " - ", p.discount.percentOff, "% off")), /*#__PURE__*/_react.default.createElement(PurchaseButton, {
        showApplication: this.showApplication,
        discussionRoot: this.discussionRoot,
        purchaseAreaInfo: p,
        doPromoCode: this.doPromoCode,
        showSurvey: this.showSurvey,
        buttonClicked: this.buttonClicked
      })), /*#__PURE__*/_react.default.createElement(MaybeContainer, {
        exposed: p.sharingEnabled || p.favoritesEnabled || this.state.discussionRoot && this.state.discussionRoot.node.report,
        tagName: "div",
        className: "actions"
      }, /*#__PURE__*/_react.default.createElement(ShareButton, {
        enabled: p.sharingEnabled,
        share: this.share
      }), /*#__PURE__*/_react.default.createElement(FavoriteButton, {
        enabled: p.favoritesEnabled,
        favorite: this.favorite,
        isFavorite: p.isFavorite
      }), /*#__PURE__*/_react.default.createElement(ReportDropdown, {
        discussionRoot: this.state.discussionRoot,
        report: this.report
      }))) : null);
    }
  }]);
  return ObjectDetailInfoBar;
}(ObjectDetailBarBase);

exports.ObjectDetailInfoBar = ObjectDetailInfoBar;
var ObjectDetailButton = (_class43 = /*#__PURE__*/function (_ObjectDetailBarBase3) {
  babelHelpers.inherits(ObjectDetailButton, _ObjectDetailBarBase3);

  var _super24 = _createSuper(ObjectDetailButton);

  function ObjectDetailButton() {
    var _this32;

    babelHelpers.classCallCheck(this, ObjectDetailButton);

    for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      args[_key22] = arguments[_key22];
    }

    _this32 = _super24.call.apply(_super24, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this32, "buyButtonText", _descriptor75, babelHelpers.assertThisInitialized(_this32));
    babelHelpers.initializerDefineProperty(_this32, "showPrice", _descriptor76, babelHelpers.assertThisInitialized(_this32));
    babelHelpers.initializerDefineProperty(_this32, "showPromoLink", _descriptor77, babelHelpers.assertThisInitialized(_this32));
    babelHelpers.initializerDefineProperty(_this32, "discussionRoot", _descriptor78, babelHelpers.assertThisInitialized(_this32));
    babelHelpers.initializerDefineProperty(_this32, "showFullDetails", _descriptor79, babelHelpers.assertThisInitialized(_this32));
    babelHelpers.initializerDefineProperty(_this32, "showMinimalPrice", _descriptor80, babelHelpers.assertThisInitialized(_this32));
    return _this32;
  }

  babelHelpers.createClass(ObjectDetailButton, [{
    key: "render",
    value: function render() {
      var p = Object.assign({
        buttonEnabled: true
      }, this.state.purchaseAreaInfo);

      if (this.showFullDetails) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "purchase-info"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "purchase-button-container"
        }, p.additionalInformation ? /*#__PURE__*/_react.default.createElement("div", {
          className: "purchase-text",
          dangerouslySetInnerHTML: {
            __html: p.additionalInformation
          }
        }) : null, p.buttonIsPurchase && p.discount && p.discount.basePrice != '$0' && /*#__PURE__*/_react.default.createElement("div", {
          className: "purchase-price"
        }, p.discount && /*#__PURE__*/_react.default.createElement("div", {
          className: "discount"
        }, "Discount applied: ", /*#__PURE__*/_react.default.createElement("span", {
          className: "basePrice"
        }, p.discount.basePrice), " - ", p.discount.percentOff, "% off")), /*#__PURE__*/_react.default.createElement(PurchaseButton, {
          showApplication: this.showApplication,
          discussionRoot: this.discussionRoot,
          purchaseAreaInfo: p,
          doPromoCode: this.doPromoCode,
          showSurvey: this.showSurvey,
          buttonClicked: this.buttonClicked,
          purchaseButtonTextOverride: this.buyButtonText,
          showPriceOverride: this.showPrice,
          showPromoOverride: this.showPromoLink,
          showMinimalPrice: this.showMinimalPrice
        })));
      }

      return /*#__PURE__*/_react.default.createElement(PurchaseButton, {
        showApplication: this.showApplication,
        discussionRoot: this.discussionRoot,
        purchaseAreaInfo: p,
        doPromoCode: this.doPromoCode,
        showSurvey: this.showSurvey,
        buttonClicked: this.buttonClicked,
        purchaseButtonTextOverride: this.buyButtonText,
        showPriceOverride: this.showPrice,
        showPromoOverride: this.showPromoLink,
        showMinimalPrice: this.showMinimalPrice
      });
    }
  }]);
  return ObjectDetailButton;
}(ObjectDetailBarBase), (_descriptor75 = babelHelpers.applyDecoratedDescriptor(_class43.prototype, "buyButtonText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor76 = babelHelpers.applyDecoratedDescriptor(_class43.prototype, "showPrice", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor77 = babelHelpers.applyDecoratedDescriptor(_class43.prototype, "showPromoLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor78 = babelHelpers.applyDecoratedDescriptor(_class43.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor79 = babelHelpers.applyDecoratedDescriptor(_class43.prototype, "showFullDetails", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor80 = babelHelpers.applyDecoratedDescriptor(_class43.prototype, "showMinimalPrice", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class43);
exports.ObjectDetailButton = ObjectDetailButton;
var ObjectDetailBar = (_class45 = /*#__PURE__*/function (_Component21) {
  babelHelpers.inherits(ObjectDetailBar, _Component21);

  var _super25 = _createSuper(ObjectDetailBar);

  function ObjectDetailBar() {
    var _this33;

    babelHelpers.classCallCheck(this, ObjectDetailBar);

    for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      args[_key23] = arguments[_key23];
    }

    _this33 = _super25.call.apply(_super25, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this33, "alternateLayout", _descriptor81, babelHelpers.assertThisInitialized(_this33));
    return _this33;
  }

  babelHelpers.createClass(ObjectDetailBar, [{
    key: "render",
    value: function render() {
      if (this.alternateLayout) {
        return /*#__PURE__*/_react.default.createElement(ObjectDetailPageHeader, this.props);
      }

      return /*#__PURE__*/_react.default.createElement(ObjectDetailInfoBar, this.props);
    }
  }]);
  return ObjectDetailBar;
}(_react.Component), (_descriptor81 = babelHelpers.applyDecoratedDescriptor(_class45.prototype, "alternateLayout", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class45);
exports.default = ObjectDetailBar;